// MarketplacePolicy.jsx
import React from 'react';
import { marketplaceGuidelinesData } from './marketplaceData';

// Minimal renderer for the keys used in the Marketplace data
function renderValueByKey(key, value) {
  // Arrays
  if (Array.isArray(value)) {
    if (key === 'steps') {
      return value.map((s, i) => (
        <div key={i} className="mb-4">
          <h3 className="font-semibold">{s.step}</h3>
          <ul className="list-disc ml-6">
            {s.details.map((d, j) => (
              <li key={j}>{d}</li>
            ))}
          </ul>
        </div>
      ));
    }

    // rules / provisions (and any other string arrays)
    return (
      <ul className="list-disc ml-6 space-y-1">
        {value.map((v, i) => (
          <li key={i}>{v}</li>
        ))}
      </ul>
    );
  }

  // Objects
  if (value && typeof value === 'object') {
    if (key === 'contact') {
      return (
        <div>
          {value.email && (
            <p>
              <span className="font-semibold">Email:</span>{' '}
              <a
                className="text-blue-600 underline"
                href={`mailto:${value.email}`}
              >
                {value.email}
              </a>
            </p>
          )}
          {value.phone && (
            <p>
              <span className="font-semibold">Phone:</span> {value.phone}
            </p>
          )}
          {value.note && <p className="text-gray-700">{value.note}</p>}
        </div>
      );
    }
    // Fallback for any unexpected object
    return (
      <pre className="bg-gray-50 p-3 rounded text-sm">
        {JSON.stringify(value, null, 2)}
      </pre>
    );
  }

  // Primitives
  return <p>{String(value)}</p>;
}

export default function MarketplacePolicy() {
  // IDs must match your sidebar dataContent anchors
  const sectionIds = [
    'general-principles',
    'guidelines-for-buyers',
    'guidelines-for-vendors',
    'prohibited-items-and-services',
    'reviews-and-ratings',
    'payments-and-fees',
    'dispute-resolution',
    'account-suspension-and-termination',
    'data-protection-and-privacy',
    'enforcement-of-guidelines',
    'policy-updates',
    'contact-us',
  ];

  return (
    <section className="max-w-4xl mx-auto py-6 scroll-smooth">
      {marketplaceGuidelinesData.map((item, index) => (
        <section
          key={index}
          id={sectionIds[index]}
          className="mb-12 scroll-mt-24"
        >
          <h2 className="text-2xl font-semibold mb-3">{item.section}</h2>

          {Object.entries(item)
            .filter(([k]) => k !== 'section')
            .map(([key, value]) => (
              <div key={key} className="mb-4">
                {['rules', 'steps', 'provisions', 'contact'].includes(key) && (
                  <h3 className="text-lg font-medium mb-2 capitalize">
                    {key.replace(/([A-Z])/g, ' $1')}
                  </h3>
                )}
                {renderValueByKey(key, value)}
              </div>
            ))}
        </section>
      ))}
    </section>
  );
}
